export const fixedTexts = {
  title:
    'Desenvolvimento de Aplicativos ou Software, em tempo recorde, com equipe especializada! Leve a transformação digital para o seu negócio!',
};
